import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import SelectVolumesModels from "./SelectVolumesModels.component";
import AreaChartComponent from "shared-components/src/components/charts/areaChart.component";
import { useDispatch, useSelector } from "react-redux";
import { getDataFromModelRequest } from "../../store/actions/realtimeDataFromModel.actions";
import { convertDataForChart, generateDataSetFromDataModel } from "./utils";

const DataFromModelsComponet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const waterSystemSelected = useSelector((state) => state.waterSystem.data);
  const waterSystems = useSelector((state) => state.waterSystems).data;
  const waterSystem = waterSystems?.find((f) => f.id === waterSystemSelected);
  const dataFromModel = useSelector((state) => state?.waterDataFromModel?.data);

  const [dataVariable, setDataVariable] = useState("storage");

  const convertedData = useMemo(
    () => convertDataForChart(dataFromModel),
    [dataFromModel],
  );
  const chartData = useMemo(
    () => generateDataSetFromDataModel(convertedData, t),
    [convertedData, t],
  );
  const chartDataByVariable = useMemo(
    () => ({
      ...chartData,
      datasets: chartData?.datasets?.filter((item) => {
        const label = item?.label?.toLowerCase();
        const variable = t(`chart.legend.${dataVariable}`)?.toLowerCase();
        return label?.includes(variable);
      }),
    }),
    [chartData, dataVariable, t],
  );

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const dataset = tooltipItem.dataset;
            const value = tooltipItem.raw?.toFixed(2) || "N/A";
            const label = dataset.label;
            const unit = dataVariable === "storage" ? "m^3 x 10^6" : "m^3/s";
            return `${label}: ${value} ${unit}`;
          },
        },
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text:
            dataVariable === "storage"
              ? `${t(
                  "real-time-page.data_from_model_chart.volumes",
                )} (m^3 x 10^6)`
              : `${t("real-time-page.data_from_model_chart.flow")} (m^3/s)`,
        },
      },
    },
  };

  useEffect(() => {
    const thing = waterSystem?.attributes?.id_thing;
    if (thing) {
      dispatch(getDataFromModelRequest(thing));
    }
  }, [waterSystem, dispatch]);

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h6" fontWeight="bold" paddingBottom={2}>
        {t("real-time-page.data-from-models")}
      </Typography>
      <Grid
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Grid item xs={12} md={2} style={{ paddingTop: "40px" }}>
          <SelectVolumesModels
            value={dataVariable}
            onChange={setDataVariable}
          />
        </Grid>
        <Grid item xs={12} md={10}>
          <Box height="auto" width="auto">
            <AreaChartComponent
              options={chartOptions}
              data={chartDataByVariable}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DataFromModelsComponet;
